import { createFileRoute } from "@tanstack/react-router"

import { ForecastCalendarContent } from "~/pages/forecasting/forecast-calendar"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/demand/_layout/sales-and-demand")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Demand - Sales & Demand")
  return <ForecastCalendarContent />
}
